import { ToggleWithLabelAndDescription } from "web/components"

export default function SummarySettings({
  showDetails,
  showGrandTotals,
  detailsDisabled = false,
  groupTotalsDisabled = false,
  showGroupTotals,
  useAverages,
  updateTable,
}) {
  function handleSettingChange(setting) {
    return (checked) => updateTable({ [setting]: checked })
  }

  function handleChangeUseSimpleAverage(checked) {
    updateTable({ use_averages: checked })
  }

  return (
    <div className="grid grid-cols-2 gap-x-5 gap-y-3">
      <ToggleWithLabelAndDescription
        label="Averages"
        description="Show averages instead of totals."
        checked={useAverages}
        onChange={handleChangeUseSimpleAverage}
      />
      <ToggleWithLabelAndDescription
        label={useAverages ? "Overall Averages" : "Grand Totals"}
        description={
          useAverages
            ? "Show averages across all data."
            : "Show grand totals for all data."
        }
        checked={showGrandTotals}
        onChange={handleSettingChange("show_grand_totals")}
      />
      <ToggleWithLabelAndDescription
        label="Data Rows when Grouped"
        description={"Include individual data rows when grouping."}
        checked={showDetails}
        disabled={detailsDisabled}
        onChange={handleSettingChange("show_details")}
      />
      <ToggleWithLabelAndDescription
        label={useAverages ? "Group Averages" : "Group Totals"}
        description={
          useAverages
            ? "Show averages for each group, when grouped."
            : "Show totals for each group, when grouped."
        }
        checked={showGroupTotals}
        disabled={groupTotalsDisabled}
        onChange={handleSettingChange("show_group_totals")}
      />
    </div>
  )
}
